<template>
    <base-layout :moduleCode="moduleCode">
    	<template v-slot:main>
			<div class="container-fluid" :class="containerClass">
	            <div class="row vh-100">
                    <div class="d-none d-md-block p-0" :class="[hasDefaultSlot?'col-md-5 col-lg-6':'col-12']">
    	                <sidebar-user></sidebar-user>
                    </div>
	                <div v-if="hasDefaultSlot" class="col-12 col-md-7 col-lg-6 ml-sm-auto px-4 d-flex align-items-sm-center pt-4 pt-sm-0">
					    <div class="row w-100 justify-content-center no-gutters">
	 				        <div class="col-12 col-md-10">
                                <div class="row d-sm-none">
                                    <div class="col text-center mb-4">
                                        <router-link :to="{ name: `${pageID}.home` }" class="logo-mobile">
                                            <img :src="assetsPathGlobalPlatform('/logo-mobile.svg')" alt="Logo mobile">
                                        </router-link>
                                    </div>
                                </div>
					            <slot></slot>
							</div>
					    </div>
					</div>
	            </div>
	        </div>
	    </template>
    </base-layout>
</template>

<script>
    import ModuleMixin from '../shared/mixins/ModuleMixin';
    import SideBarUser from '../elements/SideBarUser.vue';

    export default {
        mixins: [
            ModuleMixin,
        ],
		components: {
		    'sidebar-user': SideBarUser,
		},
        props: {
            containerClass: {
                type: [Array, Object, String],
                default: "bg-lilac-light"
            },
        },
        data() {
            return {
                pageID: 'portal',
            }
        },
        computed: {
            hasDefaultSlot () {
                return !!this.$slots['default']
            },
        },
	}

</script>

<style lang="scss" scoped>
.logo-mobile img {
    max-height: 110px;
    width: auto;
}
</style>